// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/components/StatusBar.css */

.status-bar {
  position: relative;
  overflow: visible;

  /* 固定纯色背景，内部静态 */
  background: #0b1021;
  padding: 16px;
  border-radius: 16px;
  color: #fff;
  max-width: 100%;
  margin: auto;

  /* 静态金色内边框高光 */
  border: 2px solid #00ccff;
  animation: neonPulse 2.5s ease-in-out infinite;
}

/* 金色高光内框 */
.status-bar::before {
  content: "";
  position: absolute;
  top: 2px; left: 2px; right: 2px; bottom: 2px;
  border-radius: 14px;
  border: 1px solid #ffd700;
  pointer-events: none;
}

/* 顶部行 */
.status-bar .top {
  display: flex;
  align-items: center;
  gap: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255,255,255,0.2);
}

/* Ensure top items align and visible */
.status-bar .top > div {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
}
.status-bar .top > div .icon {
  width: 20px;
  height: 20px;
  color: #00ccff;
}

/* 底部行 */
.status-bar .bottom {
  display: flex;
  align-items: center;
  padding-top: 12px;
}

/* 统计块 */
.status-bar .stat {
  flex: 1 1;
  text-align: center;
}
.status-bar .stat + .stat {
  border-left: 1px solid rgba(255,255,255,0.2);
}
.status-bar .stat div:first-child {
  font-size: 0.9rem;
  color: #fff;
}
.status-bar .stat div:last-child {
  font-size: clamp(1rem, 4vw, 1.4rem);
  min-width: 60px;
  color: #ffd700;
  margin-top: 4px;
}

/* 历史按钮 */
.status-bar .history {
  background: linear-gradient(to right, #00cfff, #0088ff);
  border: none;
  padding: 6px 12px;
  border-radius: 999px;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: bold;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.status-bar .history:hover {
  background-color: #00b8e6;
  transform: translateY(-2px);
}

/* 仅外圈彩虹流光边框 */
.status-bar::after {
  content: "";
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
  border-radius: 20px;
  background: linear-gradient(90deg, red, orange, yellow, green, cyan, blue, magenta, red);
  background-size: 400% 400%;
  z-index: -1;
  filter: blur(24px);
  animation: rainbowFlow 30s linear infinite;
  pointer-events: none;
}

@keyframes rainbowFlow {
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes neonPulse {
  0%, 100% {
    box-shadow: 0 0 8px red;
  }
  14% {
    box-shadow: 0 0 12px orange;
  }
  28% {
    box-shadow: 0 0 12px yellow;
  }
  42% {
    box-shadow: 0 0 12px green;
  }
  56% {
    box-shadow: 0 0 12px cyan;
  }
  70% {
    box-shadow: 0 0 12px blue;
  }
  84% {
    box-shadow: 0 0 12px magenta;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StatusBar.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,kBAAkB;EAClB,iBAAiB;;EAEjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;;EAEZ,cAAc;EACd,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ,EAAE,SAAS,EAAE,UAAU,EAAE,WAAW;EAC5C,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,SAAO;EACP,kBAAkB;AACpB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,uDAAuD;EACvD,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2DAA2D;AAC7D;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wFAAwF;EACxF,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,6BAA6B,EAAE;EACtC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* frontend/src/components/StatusBar.css */\n\n.status-bar {\n  position: relative;\n  overflow: visible;\n\n  /* 固定纯色背景，内部静态 */\n  background: #0b1021;\n  padding: 16px;\n  border-radius: 16px;\n  color: #fff;\n  max-width: 100%;\n  margin: auto;\n\n  /* 静态金色内边框高光 */\n  border: 2px solid #00ccff;\n  animation: neonPulse 2.5s ease-in-out infinite;\n}\n\n/* 金色高光内框 */\n.status-bar::before {\n  content: \"\";\n  position: absolute;\n  top: 2px; left: 2px; right: 2px; bottom: 2px;\n  border-radius: 14px;\n  border: 1px solid #ffd700;\n  pointer-events: none;\n}\n\n/* 顶部行 */\n.status-bar .top {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(255,255,255,0.2);\n}\n\n/* Ensure top items align and visible */\n.status-bar .top > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1rem;\n}\n.status-bar .top > div .icon {\n  width: 20px;\n  height: 20px;\n  color: #00ccff;\n}\n\n/* 底部行 */\n.status-bar .bottom {\n  display: flex;\n  align-items: center;\n  padding-top: 12px;\n}\n\n/* 统计块 */\n.status-bar .stat {\n  flex: 1;\n  text-align: center;\n}\n.status-bar .stat + .stat {\n  border-left: 1px solid rgba(255,255,255,0.2);\n}\n.status-bar .stat div:first-child {\n  font-size: 0.9rem;\n  color: #fff;\n}\n.status-bar .stat div:last-child {\n  font-size: clamp(1rem, 4vw, 1.4rem);\n  min-width: 60px;\n  color: #ffd700;\n  margin-top: 4px;\n}\n\n/* 历史按钮 */\n.status-bar .history {\n  background: linear-gradient(to right, #00cfff, #0088ff);\n  border: none;\n  padding: 6px 12px;\n  border-radius: 999px;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: bold;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n.status-bar .history:hover {\n  background-color: #00b8e6;\n  transform: translateY(-2px);\n}\n\n/* 仅外圈彩虹流光边框 */\n.status-bar::after {\n  content: \"\";\n  position: absolute;\n  top: -20px;\n  left: -20px;\n  right: -20px;\n  bottom: -20px;\n  border-radius: 20px;\n  background: linear-gradient(90deg, red, orange, yellow, green, cyan, blue, magenta, red);\n  background-size: 400% 400%;\n  z-index: -1;\n  filter: blur(24px);\n  animation: rainbowFlow 30s linear infinite;\n  pointer-events: none;\n}\n\n@keyframes rainbowFlow {\n  0%   { background-position: 0% 50%; }\n  50%  { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n@keyframes neonPulse {\n  0%, 100% {\n    box-shadow: 0 0 8px red;\n  }\n  14% {\n    box-shadow: 0 0 12px orange;\n  }\n  28% {\n    box-shadow: 0 0 12px yellow;\n  }\n  42% {\n    box-shadow: 0 0 12px green;\n  }\n  56% {\n    box-shadow: 0 0 12px cyan;\n  }\n  70% {\n    box-shadow: 0 0 12px blue;\n  }\n  84% {\n    box-shadow: 0 0 12px magenta;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
